export default {
  BUTTON: {
    APPLY: "Appliquer",
    NONE: "Aucun",
    SAVE_CHANGES: "Enregistrer les modifications",
    PROCEED: "Procéder",
    DISMISS: "Refuser",
    CONNECT: "Connecter",
    CONNECT_WALLET: "Connecter le portefeuille",
    DISCONNECT: "Déconnecter",
    LOGOUT: "Déconnexion",
    CLOSE: "Fermer",
    SETTINGS: "Réglages",
    LAUNCH_APP: "Lancer l'application",
    CONNECT_TO_PROCEED: "Connecter le portefeuille",
    VIEW_DETAILS: "Voir les détails",
    REFRESH: "Rafraîchir",
    START_REGISTRATION: "Commencer l'inscription",
    CANCEL: "Abandonner",
    PRESS_ENTER: "Appuyez sur Entrée",
    LEARN_MORE: "En savoir plus",
    CLOSE_WINDOW: "Fermer la fenêtre",
    SHOW_AVAILABLE_ONLY: "Afficher uniquement les disponibilités",
    SHOW_AVAILABLE: "Afficher uniquement les disponibilités",
    PROCEED_SEARCH: "Poursuivre la recherche",
    DOWNLOAD: "Télécharger",
    SHOW_ALL: "Tout afficher",
    DESELECT_ALL: "Désélectionner tout",
    SHOW_SELCTED: "Afficher la sélection",
    LINK: "Lier",
    CUSTOM_LINK: "Lien personnalisé",
    SET_QR_LINK_ALL: "Définir le lien QR",
    SET_QR_LINK: "Définir le lien QR",
    DISABLE_ALL: "Désactiver tout",
    DISABLE_QR_CODE: "Désactiver le QR Code",
    ENABLE_QR_CODE: "Désactiver le QR Code",
    SET_QR_COLOR: "Définir la couleur du QR",
    SET_COLOR: "Définir la couleur du QR",
    SET_ALL_COLORS: "Définir la couleur du QR",
    SET_PRICE: "Fixer le prix",
    SET_PRICE_ALL: "Fixer le prix à tous",
    RESET: 'Reset',
    CHECK_PROFILE: "Vérifier le profil",
    GO_TO_DASHBOARD: "Aller au tableau de bord",
    GO_TO_HOME: "Aller à la page d'accueil",
    VIEW_PROFILE: "Voir le profil",
    CHECK_DOMAINS: "Vérifier les domaines",
    TRANSACTION_DETAILS: "Détails de la transaction",
    BUY_NOW: "Acheter maintenant",
    CLEAR_HISTORY: "Effacer l'historique",
    DEFAULT: "Par défaut",
    CUSTOM: "Personnaliser",
    FRACTIONALISE: "Fractionaliser",
    MORE_INFO: "Plus d'informations",
    LESS_INFO: "Moins d'info",
    APPROVE: "Approuver",
    NEXT: "Suivant",
    PENDING: "En attente",
    REMOVE: "Retirer",
    REMOVE_ALL_ITEMS: "Supprimer tous les éléments",
    ADD_ALL_TO_CART: "Tout ajouter au panier",
    BOOKMARK_ALL: "Marquer tous les favoris",
    DOWNLOAD_LIST: "Liste des téléchargements",
    SHARE_LIST: "Partager la liste",
    MORE: "Plus d’infos",
    CHANGE: "Modifier",
    TRY_AGAIN: "Essayez encore"
  },
  HEADER: {
    ABOUT: "À propos",
    FAQ: "Foire aux questions",
    BACK_TO_HOME: "Retour à la page d'accueil",
    HOME: "Retour",
    CATEGORIES: "Catégories",
    HELP_SUPPORT: "Aide & Support",
    HELP: "Aide",
    CANCEL_REGISTRATION: "Annuler l'inscription",
    PROFILE: "Profil",
    SETTINGS: "Réglages",
    DOCS: "Documents",
    DOCUMENTATIONS: 'Documentations',
    CART: "Panier",
    BOOKMARKS: "Signets",
    PAYMENTS_HISTORY: "Historique des paiements",
    LIGHT_MODE: "Mode clair",
    CUSTOM_RPC: "RPC personnalisé",
    SETUP_REQUIRED: "Configuration requise",
    MANAGE_DOMAINS: "Gestion Domaines",
    APPROVE: "Approuver",
    FEATURE_DISABLED: "Fonction désactivée",
    ERROR: "Erreur"
  },
  IPFS: {
    INITIALISING: "Démarrage p2p",
    FINDING_PEERS: "Recherche de pairs",
    FAILED: "Echoué",
    READY: "Prêt",
    PUBLISHING: "Publication en cours"
  },
  EVENTS: {
    TRANSFER: "Transférer",
    REGISTRATION: "Inscription",
    RENEWAL: "Renouvellement",
    SALE: "Vente",
    MINT: "Médicaments",
    BURN: "Brûlure"
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE: "Le réseau n'est pas pris en charge. Veuillez modifier votre réseau.",
    IPNS_PUBLISHING_COMPLETED: "Publication terminée !",
    PENDING_TRANSACTION_CERATED: "Une nouvelle transaction a été créée. Veuillez vérifier votre portefeuille."
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: "1 semaine",
    ONE_MONTH: "1 mois",
    THREE_MONTHS: "3 Mois",
    SIX_MONTHS: "6 Mois",
    ONE_YEAR: "1 an",
    TWO_YEARS: "2 Ans",
    THREE_YEARS: "3 Ans",
    FOUR_YEARS: "4 Ans",
    FIVE_YEARS: "5 Ans"
  },
  LABELS: {
    DOWNLOAD_DATA: "Télécharger les Données",
    SORT_BY_EXPIRATIONS: "Trier par expiration",
    SORT_BY_LATEST_REGISTRATIONS: "Trier par les dernières inscriptions",
    SORT_BY_LONGEST_DURATION: "Trier par référence la plus longue durée",
    PREMIUM: 'Premium',
    ANALYTICS: "Analytiques",
    AN_ERROR_HAS_OCCURED: "Une erreur est survenue lors du traitement de votre demande.",
    STOREFRONT_READY_TO_DEPLOY: "La devanture de votre boutique est prête à être déployée. Votre boutique sera située à:",
    ACCESS_STOREFRONT: "Vous pouvez maintenant accéder à la devanture de votre boutique sur :",
    BUY_ON: "Acheter sur",
    MY_PROFILE: "Mon profil",
    CREATE_STOREFRONT: "Créer une vitrine",
    SETUP_PRIMARY_DOMAIN: "Configurer le domaine principal",
    CHOOSE_A_PRIMARY_DOMAIN: "Choisissez un domaine principal et liez le à votre profil. Ce domaine choisi sera votre lien de profil.",
    CREATE_YOUR_STOREFRONT: "Créez votre vitrine de boutique en utilisant votre nom .eth avec Predomain Stores. Apprenez-en plus sur la vitrine de votre boutique sur :",
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE: "Ce domaine est disponible sur les places de marché suivantes",
    PURCHASE_DOMAINS: "Acheter des Domaines",
    OWNED_BY: "Propriété de",
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: "Gérer les articles en vedette",
    VISIT_STOREFRONT: "Visiter la vitrine",
    OPTIONS: 'Options',
    FEATURED_ITEMS: "Articles en vedette",
    SORT_BY_CATEGORY: "Trier par catégorie",
    SELECT_DOMAIN: "Sélectionnez le domaine",
    SELECT_DOMAINS: "Sélectionner les domaines",
    RENEW_DOMAINS: "Renouveler les domaines",
    TRANSFER_DOMAINS: "Transférer des domaines",
    BUYER: "Acheteur",
    PRICE: "Hinta",
    SALE: "Vente",
    ACTIVITY: "Activité",
    TOP_CATEGORIES: "Catégories Top",
    TOTAL_ASSETS: "Total des biens",
    MONTHLY_SALES: "Ventes mensuelles",
    DAILY_VOLUME: "Volume quotidien",
    MONTHLY_VOLUME: "Volume mensuel",
    DAILY_SALES: "Journal Des Ventes",
    TOP_SALE: "Meilleure vente",
    TOP_SALES: "Meilleures ventes",
    TOP_BUYER: "Meilleur Acheteur",
    RECENT_SALES: "Ventes récentes",
    SALES_ACTIVITY: "Activité des ventes",
    ENTER_NAMES_TO_SEARCH: "Entrez les noms à rechercher",
    NOT_AVAILABLE: "Non disponible",
    VOLUME: 'Volume',
    FLOOR: "Sol",
    FILTER: "Filtre",
    RENEWAL_DURATION: "Durée du Renouvellement",
    TRANSACTION: 'Transaction',
    USER_PROFILE: "Profil de l'utilisateur",
    FEATURE_DISABLED: "Cette fonctionnalité est actuellement désactivée.",
    COMPLETE: "Compléter",
    ESTIMATED_COST: "Coût estimé",
    ADDRESS: "Adresse",
    TRANSFER: "Transférer",
    PLEASE_WAIT: "Je vous laisse attendre :",
    SELECT_A_DOMAIN: "Sélectionner un domaine",
    RENEW: 'Renew',
    MANAGE_DOMAINS: "Gestion Domaines",
    SEARCH_FOR: "Rechercher",
    MANAGE: "Gérer",
    COLLECT: "Prendre",
    LANDING_TEXT: "Open source, décentralisé, Web3 domaines de recherche, enregistrement & marketplace.",
    PROFILE: "Profil",
    GO_TO_PROFILE: "Aller au Profil",
    SEARCH: "Chercher",
    CONTAIN_ALPHABET: "Contient l'alphabet",
    CONTAIN_NUMBERS: "Contient des nombres",
    CONTAIN_EMOJI: "Contient des émoticônes",
    MIN_LENGTH: "Longueur min.",
    MAX_LENGTH: "Longueur Max.",
    CONTAINING_KEYWORDS: "Contenant des mots-clés",
    FILTERS: "Filtres",
    DOMAINS: "Domaines",
    DOMAIN: "Verkkotunnus",
    DOMAIN_HISTORY: "Historique du domaine",
    EXPIRATION_DATE: "Date d'expiration",
    REGISTRATION_DATE: "Inscription",
    CREATION_DATE: "Date de Création",
    DETAILS: "Détail",
    YOUR_DOMAINS: "Vos domaines",
    PROCESSING: "En cours de traitement",
    LAYOUT: "Disposition",
    ENTER_SUFFIX: "Saisir le suffixe",
    ENTER_PREFIX: "Entrez le préfixe",
    CLICK: 'Click',
    CONNECT_TO_START: " pour commencer ou ",
    TIP: 'Tip',
    ACTION: 'Action',
    ACTIONS: 'Actions',
    ADVANCED_SEARCH_TIP: "utilisez une nouvelle ligne ou une nouvelle virgule pour séparer vos entrées de domaine.",
    ADVANCED_SEARCH: "Recherche avancée",
    ADVANCED_MODE: "Mode Avancé",
    REGISTER_DOMAINS_TO: "Enregistrer les domaines à",
    NO_DOMAINS_SELECTED: "Aucun domaine sélectionné.",
    FIND_AND_REGISTER: "Enregistrer les domaines par exemple domaine1, domaine2...",
    SELECTED_DOMAINS: "Domaines sélectionnés",
    REGISTER: "Inscription",
    BOOKMARKS: "Signets",
    SEARCH_RESULTS: "Résultats de recherche",
    PROCEED_TO_REGISTRATION: "Procéder à l'inscription",
    REGISTER_DOMAINS: "Enregistrer les domaines à",
    REGISTRANT_ADDRESS: "Adresse de l'inscrit",
    SET_RESOLVER: "Définir le résolveur",
    TOTAL_COST: "Coût total",
    GAS_PRICE: "Prix du gaz",
    NO_ADDRESS_DETECTED: "Aucune adresse détectée.",
    DURATION: "Durée",
    NOTICE_SELECT_AN_RPC: "Remarque : sélectionnez un RPC qui sera utilisé dans l'application pour remplacer le fournisseur RPC par défaut.",
    ENABLE_LIGHT_MODE: "Activer le style de mise en page léger.",
    CLICK_NEXT_TO_PROCEED: "Cliquez sur <b>Suivant</b> pour continuer."
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: "Inscription annulée",
    REGISTRATION_CANCELLED_DESCRIPTION: "Votre inscription a été annulée.",
    CANCEL_REGISTRATION_TITLE: "Annuler l'inscription",
    CANCEL_REGISTRATION_DESCRIPTION: "Êtes-vous sûr de vouloir annuler cette inscription ? Cette action ne peut pas être annulée.",
    BEFORE_COMMIT: "Étape 1 : demande d'inscription.",
    COMMIT_SENT: "Traitement de la requête...",
    COMMIT_COMPLETE: "Étape 1 : demande d'inscription...",
    AWAIT: "Traitement de la requête...",
    BEFORE_REGISTRATION: "Terminer l'inscription.",
    REGISTRATION_SENT: "Fin de l'inscription...",
    REGISTRATION_COMPLETE: "Inscription!",
    REGISTRATION_COMPLETE_TITLE: "Inscription",
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED: "Vos domaines ont été enregistrés.",
    BASKET_EMPTY: "Votre panier est vide",
    PLEASE_SELECT_DOMAINS_TO_REGISTER: "Veuillez sélectionner de nouveaux domaines à enregistrer."
  },
  PAYMENT: {
    PAYMENT_CANCELLED: "Transaction annulée. Veuillez réessayer."
  },
  SPINNER: {
    SETUP_COMPLETE: "Mise en place terminée",
    LEDGER_NO_DEVICE_SELECTED: "Une erreur est survenue lors de la connexion à votre portefeuille. Veuillez réessayer.",
    NO_DATA_TO_DISPLAY: "Aucun élément à afficher.",
    PERFORMING_SEARCH: "Recherche en cours...",
    LOADING_DATA: "Chargement des données...",
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET: "Veuillez suivre les instructions de votre portefeuille pour continuer."
  },
  FORM_LABELS: {
    ENTER_DURATION: "Entrez la durée",
    ENTER_QR_LINK: "Entrez l'URL du QR Code personnalisé",
    ENTER_PRICE: "Entrez le prix",
    ENTER_CUSTOM_ADDRESS: "Entrez une adresse personnalisée",
    ENTER_RECEIVER_ADDRESS: "Entrez l'adresse du destinataire"
  },
  FORM_ERRORS: {
    INVALID_DURATION: "Durée non valide",
    INVALID_QR_LINK: "URL invalide, veuillez réessayer.",
    INVALID_PRICE: "URL invalide, veuillez réessayer.",
    NO_ADDRESS_DETECTED: "Aucune adresse détectée, veuillez réessayer.",
    INVALID_ADDRESS: "Adresse invalide, veuillez réessayer."
  },
  STEP: {
    STEP_1: "Etape 1",
    STEP_2: "Etape 2",
    STEP_3: "Etape 3",
    STEP_4: "Etape 4",
    STEP_5: "Etape 5"
  },
  RENEW: {
    RENEWAL_COST: "Coût de Renouvellement",
    ESTIMATED_RENEWAL_COST: "Voici le coût estimé de renouvellement de cette transaction.",
    RENEWAL_COMPLETE: "Renouvellement terminé",
    DOMAINS_READY_FOR_RENEWAL: " Vos domaines sont maintenant prêts à être renouvelés. Pour finaliser votre renouvellement, appuyez sur continuer."
  },
  TRANSFER: {
    TRANSFER_TO: "Transfert vers",
    TRANSFER_COMPLETE: "Transfert terminé !",
    SETUP_INSTRUCTION: "Pour activer la gestion des domaines ENS, votre compte doit être configuré pour approuver les transferts de domaine.",
    CONTRACT_APPROVAL_NOTE: "L'approbation du contrat permet au contrat d'effectuer des transferts de domaines en votre nom.",
    DOMAINS_READY_FOR_TRANSFER: "Vos domaines sont maintenant prêts pour le transfert. Entrez l'adresse du destinataire et appuyez sur continuer."
  }
};